import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DashboardService } from '../../../services/dashboard.service';
import { InsrAcqnDashboardDetails, InsuranceAcquisitionDetails, SelectedInsrReports } from '../../../model/InsuranceAcquisitionDetails';
import { SelectItem } from '@fm-ui-adk/components-3/common/model';
import * as _ from 'lodash-es';
import { AcqnFilterService } from 'src/app/services/acqn-filter-service';
import { AcqnFiltersDetails } from '../../model/AcqnFiltersDetails';
import { FilterDetailsSourceType } from 'src/app/shared/enum-value';
import { AcqnDownloadService } from 'src/app/services/acqn-download.service';
import { UserRoles } from 'src/app/model/UserRoles';
import { UserRolesService } from 'src/app/services/user-roles.service';
import { InsuranceService } from 'src/app/services/insurance.service';
import { StatsDataService } from 'src/app/services/stats-data.service';
import { InsrDownloadService } from 'src/app/services/insr-download.service';


@Component({
  standalone: false,
  selector: 'app-acquisitions-insurance',
  templateUrl: './acquisitions-insurance.component.html',
  styleUrls: ['./acquisitions-insurance.component.css'],
  providers: [DashboardService]

})
export class AcquisitionsInsuranceComponent implements OnInit {

  // https://angular.io/guide/component-interaction
  @Input() set acqnDetails(acqnDetails: InsuranceAcquisitionDetails) {
    this._acqnDetails = acqnDetails;
    // this.resetDropDownPlaceHolders('tabChange');
    this.loadAcquisitionTabData();
    this.applyFilters();
  }
  private _acqnDetails: InsuranceAcquisitionDetails;

  @Input() selectStartPeriod: any[] = [];
  @Input() selectedStartPeriod: string = "";
  @Input() selectEndPeriod: any[] = [];
  @Input() selectedEndPeriod: string = "";

  @Input() isInternal: boolean = false;
  @Input() showAcqnTableEditCheckbox: boolean = false;
  @Input() showUploadFiles;

  @Output() refreshAcqnDetails: EventEmitter<object> = new EventEmitter<object>();
  @Output() getEndPeriodDates: EventEmitter<object> = new EventEmitter<object>();
  @Output() openAcqnFilterSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() openAcqnPropertyDetailsSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() selectedPropertyDetails: EventEmitter<object> = new EventEmitter<object>();

  numberOfPreAcquisitionDeals: number = 0;
  countDisplayedInsrAqsnList: number = 0;

  showAcqnUpdateInsuranceComponent = false;

  acqnDetailsDashboardDisplay: InsrAcqnDashboardDetails[] = [];
  acqnDetailsDashboardDisplayTemp: InsrAcqnDashboardDetails[];

  acqsnLenderList: any[] = [];
  acqsnSelectedLender: string = '';
  acquisitionStatusFilterList: any[] = [];
  acquisitionStatusFilterSelected: string = '';
  lnPurpsTypeList: SelectItem[] = [];
  lnPurpsTypeSelected: string = '';
  lnRefiTypeList: SelectItem[] = [];
  lnRefiTypeSelected: string = '';
  lnBalanceList: SelectItem[] = [];
  lnBalanceSelected: string = '';
  txTypeList: SelectItem[] = [];
  txTypeSelected: string = '';
  requireFloodINSSelected = '';
  requireFloodINSList: SelectItem[] = [];

  selectedReportArrayDisplay: SelectedInsrReports[] = [];
  cols5: any[];

  filteredData = [];

  tableSearchText: string = '';

  userRoles: UserRoles;
  enableDownloadButton: boolean = false;  //Based on table row count
  showDownloadButton: boolean = false;  //Based on user role

  constructor(private acqnDownloadService: AcqnDownloadService,
    private acqnFiltersService: AcqnFilterService,
    private userRolesService: UserRolesService,
    private insuranceService: InsuranceService,
    private statsDataService: StatsDataService,
    private insrDownloadService: InsrDownloadService) {
  }

  ngOnInit(): void {

    // get user roles
    this.userRolesService.userRoles$.subscribe(data => {
      this.userRoles = data;
    });

    this.acqnFiltersService.acqnInsuranceFiltersDetailsSub.subscribe((acqnFiltersDetails: AcqnFiltersDetails) => {
      if ((acqnFiltersDetails.source.includes(FilterDetailsSourceType.INSAcq))  &&
         (acqnFiltersDetails.source.includes(FilterDetailsSourceType.AcqnInsuranceFilter))) {
        this.selectedStartPeriod = acqnFiltersDetails.startPeriod;
        this.selectedEndPeriod = acqnFiltersDetails.endPeriod;
        this.isInternal = acqnFiltersDetails.isInternal;
        this.acqsnSelectedLender = acqnFiltersDetails.lender;
        this.acquisitionStatusFilterSelected = acqnFiltersDetails.acquisitionStatus;
        this.lnPurpsTypeSelected = acqnFiltersDetails.supplemental;
        this.lnRefiTypeSelected = acqnFiltersDetails.loanRefinanceType;
        this.lnBalanceSelected = acqnFiltersDetails.smallLoanBalance;
        this.txTypeSelected = acqnFiltersDetails.transactionType;
        this.requireFloodINSSelected = acqnFiltersDetails.requireFloodINS;

        this.applyFilters();
      }
    });

    this.cols5 = [
      { field: 'propNme', header: 'Property Name' },
      { field: 'dusDealId', header: 'DUS Gateway Deal ID' },
      { field: 'dlNme', header: 'Deal Name' },
      { field: 'coltRefNo', header: 'Collateral Reference #' },
      { field: 'aqsnDealId', header: 'Acquisition Deal ID' },
      { field: 'aqsnDt', header: '(Est.) Acquisition Date' },
      { field: 'reqdSubmtDt', header: 'Required Submission Date' },
      { field: 'propInsrSubmtDt', header: 'Last Submitted Date' },
      { field: 'complianceRate', header: 'Status' }
    ];

    this.showHideDownloadButton();
  }

  private showHideDownloadButton() {
    if (this.countDisplayedInsrAqsnList > 0)
      this.enableDownloadButton = true;
    else
      this.enableDownloadButton = false;

    //Set the show/hide based on the user role
    this.showDownloadButton = true;
    if (this.userRoles) {
      if (this.userRoles.isMAUser || this.userRoles.isAssetManager) {
        this.showDownloadButton = false;
      }
      if (this.userRoles.isExternalUser || this.userRoles.isAdminUser || this.userRoles.isMFOpsUser) {
        this.showDownloadButton = true;
      }
    }
  }

  public loadAcquisitionTabData() {

    if (this._acqnDetails.acqInsuranceDetails) {
      this.acqnDetailsDashboardDisplay = this._acqnDetails.acqInsuranceDetails;
      this.acqnDetailsDashboardDisplayTemp = this._acqnDetails.acqInsuranceDetails;
      this.updateStats();
      this.countDisplayedInsrAqsnList = this._acqnDetails.acqInsuranceDetails.length;
    } else {
      this.acqnDetailsDashboardDisplay = [];
      this.countDisplayedInsrAqsnList = 0;
    }

    this.selectedReportArrayDisplay = [];
    this.loadDropDownFilterLists();
    this.showHideDownloadButton();
  }

  public updateStats() {
    let lenderStats = this.insuranceService.complianceCalculationInsurance(this.acqnDetailsDashboardDisplay, this.requireFloodINSSelected);
    this.statsDataService.setStatsDataDetails(lenderStats);
    this.statsDataService.notifySubscribers();
  }

  public resetDropDownPlaceHolders(field: string) {
    if (field == 'purpsTypSpmt') {
      this.lnRefiTypeSelected = '';
      this.lnBalanceSelected = '';
      this.txTypeSelected = '';
    } else if (field == 'refType') {
      this.lnPurpsTypeSelected = '';
      this.lnBalanceSelected = '';
      this.txTypeSelected = '';
    } else if (field == 'lnBalance') {
      this.lnPurpsTypeSelected = '';
      this.lnRefiTypeSelected = '';
      this.txTypeSelected = '';
    } else if (field == 'transType') {
      this.lnPurpsTypeSelected = '';
      this.lnRefiTypeSelected = '';
      this.lnBalanceSelected = '';
    } else if (field == 'acquisitionStatus') {
      this.acqsnSelectedLender = '';
      this.lnPurpsTypeSelected = '';
      this.lnRefiTypeSelected = '';
      this.lnBalanceSelected = '';
      this.txTypeSelected = '';
    } else if (field == 'tabChange') {
      this.acqsnSelectedLender = '';
      this.acquisitionStatusFilterSelected = '';
      this.lnPurpsTypeSelected = '';
      this.lnRefiTypeSelected = '';
      this.lnBalanceSelected = '';
      this.txTypeSelected = '';
    } else {
      this.acquisitionStatusFilterSelected = '';
      this.lnPurpsTypeSelected = '';
      this.lnRefiTypeSelected = '';
      this.lnBalanceSelected = '';
      this.txTypeSelected = '';
    }
  }

  public loadDropDownFilterLists() {
    // Lender Names
    if (this._acqnDetails.lenderNames) {
      this.acqsnLenderList = [{ label: 'All', value: '' }];
      if (this._acqnDetails.lenderNames) {
        for (let i = 0; i < this._acqnDetails.lenderNames.length; i++) {
          this.acqsnLenderList.push({ label: this._acqnDetails.lenderNames[i], value: this._acqnDetails.lenderNames[i] });
        }
        this.acqsnLenderList = _.sortBy(this.acqsnLenderList, ['value']);
      }
    } else {
      this.acqsnLenderList = [{ label: 'All', value: '' }];
    }

    // Acquisition Dashboard Details
    if (this._acqnDetails.acqInsuranceDetails) {
      let tempVar: any[];

      // acquisition status
      this.acquisitionStatusFilterList = [
        { label: 'All', value: '' },
        { label: 'Acquired', value: 'Acquired' },
        { label: 'Committed', value: 'Pre-Acquisition' }
      ];

      // loan purpose type(s)
      this.lnPurpsTypeList = [{ label: 'All', value: '' }];
      tempVar = [...new Set(this._acqnDetails.acqInsuranceDetails.map((o) => o.purpsTypSpmt))];
      for (let i = 0; i < tempVar.length; i++) {
        if (tempVar[i] != null) {
          this.lnPurpsTypeList.push({ label: tempVar[i], value: tempVar[i] });
        }
        else if (tempVar[i] == null || tempVar[i] == '') {
          this.lnPurpsTypeList.push({ label: '-- Not Provided --', value: null });
        }
      }

      // loan refinance type(s)
      this.lnRefiTypeList = [{ label: 'All', value: '' }];
      tempVar = [...new Set(this._acqnDetails.acqInsuranceDetails.map((o) => o.refType))];
      for (let i = 0; i < tempVar.length; i++) {
        if (tempVar[i] != null) {
          this.lnRefiTypeList.push({ label: tempVar[i], value: tempVar[i] });
        }
        else if (tempVar[i] == null || tempVar[i] == '') {
          this.lnRefiTypeList.push({ label: '-- Not Provided --', value: null });
        }
      }

      // loan balance indicator(s)
      this.lnBalanceList = [{ label: 'All', value: '' }];
      tempVar = [...new Set(this._acqnDetails.acqInsuranceDetails.map((o) => o.lnBalance))];
      for (let i = 0; i < tempVar.length; i++) {
        if (tempVar[i] != null) {
          this.lnBalanceList.push({ label: tempVar[i], value: tempVar[i] });
        }
        else if (tempVar[i] == null || tempVar[i] == '') {
          this.lnBalanceList.push({ label: '-- Not Provided --', value: null });
        }
      }

      // transaction type(s)
      this.txTypeList = [{ label: 'All', value: '' }];
      tempVar = [...new Set(this._acqnDetails.acqInsuranceDetails.map((o) => o.transType))];
      for (let i = 0; i < tempVar.length; i++) {
        if (tempVar[i] != null) {
          this.txTypeList.push({ label: tempVar[i], value: tempVar[i] });
        }
        else if (tempVar[i] == null || tempVar[i] == '') {
          this.txTypeList.push({ label: '-- Not Provided --', value: null });
        }
      }
      //this.txTypeList = _.sortBy(this.txTypeList, ['value']);
    } else {
      this.lnPurpsTypeList = [{ label: 'All', value: '' }];
      this.lnRefiTypeList = [{ label: 'All', value: '' }];
      this.lnBalanceList = [{ label: 'All', value: '' }];
      this.txTypeList = [{ label: 'All', value: '' }];
    }
  }

  public applyFilters() {
    this.acqnDetailsDashboardDisplay = this._acqnDetails.acqInsuranceDetails;

    //acquisition status
    if (this.acquisitionStatusFilterSelected != '')
      this.acqnDetailsDashboardDisplay = _.filter(this.acqnDetailsDashboardDisplay, ['acquisitionStatus', this.acquisitionStatusFilterSelected])

    //lender
    if (this.acqsnSelectedLender != '')
      this.acqnDetailsDashboardDisplay = _.filter(this.acqnDetailsDashboardDisplay, ['lender', this.acqsnSelectedLender])

    //require flood insurance
    if (this.requireFloodINSSelected == 'Y')
      this.acqnDetailsDashboardDisplay = _.filter(this.acqnDetailsDashboardDisplay, ['propFloodInsrReq', true])
    else if (this.requireFloodINSSelected == 'N')
      this.acqnDetailsDashboardDisplay = _.filter(this.acqnDetailsDashboardDisplay, ['propFloodInsrReq', false])

    //supplemental
    if (this.lnPurpsTypeSelected != '')
      this.acqnDetailsDashboardDisplay = _.filter(this.acqnDetailsDashboardDisplay, ['purpsTypSpmt', this.lnPurpsTypeSelected])

    //loan refinance type
    if (this.lnRefiTypeSelected != '')
      this.acqnDetailsDashboardDisplay = _.filter(this.acqnDetailsDashboardDisplay, ['refType', this.lnRefiTypeSelected])

    //small loan balance
    if (this.lnBalanceSelected != '')
      this.acqnDetailsDashboardDisplay = _.filter(this.acqnDetailsDashboardDisplay, ['lnBalance', this.lnBalanceSelected])

    //transaction type
    if (this.txTypeSelected != '')
      this.acqnDetailsDashboardDisplay = _.filter(this.acqnDetailsDashboardDisplay, ['transType', this.txTypeSelected])

    //recalculate dashboard metrics
    this.updateStats();
    //this.countAqsnList = _.filter(this.acqnDetailsDashboardDisplay, {active: true}).map((item, index) => ({item:this.acqnDetailsDashboardDisplay,counter:index+1}));
    this.countDisplayedInsrAqsnList = this.acqnDetailsDashboardDisplay.length;
    this.showHideDownloadButton();
  }

  // Do a callback and refresh the acqnDetails
  public onRefreshAcqnDetails() {
    // Get start and end date and do a callback to get a new list
    let startDate: string = this.selectedStartPeriod;
    let endDate: string = this.selectedEndPeriod;
    let isLenderRanking: boolean = false;

    this.refreshAcqnDetails.emit({ startDate, endDate, isLenderRanking });
  }

  onGetEndPeriodDates() {
    // Get start and end date and do a callback to get a new list
    let startDate: string = this.selectedStartPeriod;
    let endDate: string = this.selectedEndPeriod;
    let isLenderRanking: boolean = false;
    let onload: boolean = false;

    this.getEndPeriodDates.emit({ startDate, endDate, isLenderRanking, onload });
  }

  showUpdateReportComponent() {
    this.showAcqnUpdateInsuranceComponent = true;
  }

  onAcqnUpdateTableClose(refresh: boolean) {
    console.log("acquisitions.component.ts::onAcqnUpdateTableClose - refresh = ", refresh);
    
    this.showAcqnUpdateInsuranceComponent = false;
    if (refresh) {
      this.onRefreshAcqnDetails();
    }
  }

  showAcqnFilterSidebar() {
    this.acqnFiltersService.setSource(FilterDetailsSourceType.INSAcq);
    this.acqnFiltersService.setStartPeriod(this.selectedStartPeriod);
    this.acqnFiltersService.setEndPeriod(this.selectedEndPeriod);

    this.acqnFiltersService.setIsInternal(this.isInternal);
    if (this.isInternal) {
      this.acqnFiltersService.setLender(this.acqsnSelectedLender);
      this.acqnFiltersService.setLenderList(this.acqsnLenderList);
    }

    this.acqnFiltersService.setAcquisitionStatus(this.acquisitionStatusFilterSelected);
    this.acqnFiltersService.setAcquisitionStatusList(this.acquisitionStatusFilterList);

    this.acqnFiltersService.setSupplemental(this.lnPurpsTypeSelected);
    this.acqnFiltersService.setSupplementalList(this.lnPurpsTypeList);

    this.acqnFiltersService.setLoanRefinanceType(this.lnRefiTypeSelected);
    this.acqnFiltersService.setLoanRefinanceTypeList(this.lnRefiTypeList);

    this.acqnFiltersService.setSmallLoanBalance(this.lnBalanceSelected);
    this.acqnFiltersService.setSmallLoanBalanceList(this.lnBalanceList);

    this.acqnFiltersService.setTransactionType(this.txTypeSelected);
    this.acqnFiltersService.setTransactionTypeList(this.txTypeList);

    this.acqnFiltersService.setRequireFloodINS(this.requireFloodINSSelected);
    this.acqnFiltersService.setRequireFloodINSList(this.requireFloodINSList);

    this.acqnFiltersService.notifySubscribers();

    this.openAcqnFilterSidebar.emit(true);
  }

  showAcqnPropertyDetailsSidebar(rowData: any) {
    let source = this.acqnFiltersService.getSource();
    if (source == "" || source == 'AcquisitionsPropertyDetails') {
      this.acqnFiltersService.setSource('AcquisitionsPropertyDetails');
      this.selectedPropertyDetails.emit(rowData);
      this.openAcqnPropertyDetailsSidebar.emit(true);
    }
  }

  public downloadAcquisitionDealDetails(filteredData: InsrAcqnDashboardDetails[]) {
    if (filteredData == null) {
      filteredData = this.acqnDetailsDashboardDisplay;
    }

    if (this.acquisitionStatusFilterSelected == 'Pre-Acquisition') {
      this.acquisitionStatusFilterSelected = 'Committed';
    }

    this.insrDownloadService.exportToExcel(filteredData,
      { tableSearchText: this.tableSearchText,
        startDate: this.selectedStartPeriod,
        endDate: this.selectedEndPeriod,
        isInternal: this.isInternal,
        selectedLender: this.acqsnSelectedLender,
        requireFloodINS: this.requireFloodINSSelected,
        acquisitionStatus: this.acquisitionStatusFilterSelected,
        supplemental: this.lnPurpsTypeSelected,
        loadFinanceType: this.lnRefiTypeSelected,
        smallLoanBalance: this.lnBalanceSelected,
        transactionType: this.txTypeSelected
      });
  }

  public onFilteredAcqnTable(acqntbl) {
    this.tableSearchText = acqntbl.filters.global?.value || '';

    const filteredData = acqntbl.filteredValue;
    this.countDisplayedInsrAqsnList = filteredData?.length || this._acqnDetails.acqInsuranceDetails.length;

    this.showHideDownloadButton();
  }
}
